import { throwError as observableThrowError } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { debounceTime, catchError } from 'rxjs/operators';

import { GlobalVariables } from '../global';
import { DataService } from './data.service';
import { GetBranchQueueResponse, GetPrinterResponse, GetTokenResponse, PrinterData } from '../_types/api.types';
import { GetBranchQueueIntegrationsRes } from 'app/common/_types';

@Injectable()
export class PrinterEndpointsService {
  private basicUrl = GlobalVariables.BASE_API_URL + '/api/v1/branches';
  constructor(
    private http: HttpClient,
    private dataService: DataService,
  ) {}

  getPrinterData(branchId: string | number, printerId: string | number) {
    const headers = this.defaultHeaders();
    const options = { headers };

    const queryParams = '?include=branch_queues,branch_queues,serving_token_for_current_day,printer_customization';

    const url = `${this.basicUrl}/${branchId}/printers/${printerId}${queryParams}`;

    return this.http.get<GetPrinterResponse>(url, options).pipe(catchError(this.handleError));
  }

  generateQueueToken(printerData: PrinterData, branchQueueId: string | number, branchId: string | number) {
    const headers = this.defaultHeaders();
    const options = { headers };
    const isTicketLess = printerData?.printerType === 'ticket_less';

    const url = `${this.basicUrl}/${branchId}/branch_queues/${branchQueueId}/tokens`;

    return this.http
      .post<GetTokenResponse>(
        url,
        {
          branch_queue_id: branchQueueId,
          origin_type: isTicketLess ? 'ticket_less' : 'web_paper',
        },
        options,
      )
      .pipe(debounceTime(500), catchError(this.handleError));
  }

  updatePrinterIpAddress(branchId: string | number, data: { printer: PrinterData; ipValue: string }) {
    const headers = this.defaultHeaders();
    const options = { headers };

    let url = this.basicUrl + '/' + branchId + '/printers/' + data.printer.id;

    return this.http
      .post(
        url,
        JSON.stringify({
          printer: { id: data.printer.id, ip_address: data.ipValue },
        }),
        options,
      )
      .pipe(catchError(this.handleError));
  }

  createTokenViaBooking(branchId: string, bookingCode: string) {
    const headers = this.defaultHeaders();
    const options = { headers };

    const url = `${this.basicUrl}/${branchId}/tokens/create_via_booking`;

    return this.http.post<GetTokenResponse>(url, { code: bookingCode }, options).pipe(catchError(this.handleError));
  }

  getBranchQueueIntegrations(branchId: string | number, page = 1, pageSize = 10) {
    const headers = this.defaultHeaders();
    const options = { headers };

    const url = `${this.basicUrl}/${branchId}/branch_queue_integrations?page=${page}&page_size=${pageSize}`;

    return this.http.get<GetBranchQueueIntegrationsRes>(url, options).pipe(catchError(this.handleError));
  }

  getBranchQueue(id: string | number, branchId: string | number) {
    const headers = this.defaultHeaders();
    const options = { headers };

    const url = `${this.basicUrl}/${branchId}/branch_queues/${id}`;

    return this.http.get<GetBranchQueueResponse>(url, options).pipe(catchError(this.handleError));
  }

  private handleError(err: Response | any) {
    return observableThrowError(() => err.json().errors);
  }

  defaultHeaders() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    headers = headers.append('ACCESS-TOKEN', this.dataService.sessionData());
    return headers;
  }
}
